import { Divider, Link, Typography } from '@mui/material';
import { t } from '@ankr.com/common';
import { useLocation } from 'react-router';

import {
  ANKR_PRIVACY_POLICY_LINK,
  ANKR_TERMS_OF_SERVICE_LINK,
} from 'modules/common/constants/const';
import { projectsV2RoutesConfig } from 'domains/projects/routes';
import { featureConfig } from 'modules/common/featureConfig';

import AnkrLogo from '../../assets/ankr.svg?react';
import BlockrailLogo from '../../assets/blockrail_logo.svg?react';
import { useFooterStyles } from './useFooterStyles';

const { path: newProjectPath } = projectsV2RoutesConfig.newProject;

export const Footer = () => {
  const { pathname: currentPath } = useLocation();
  const isNewProjectPage = currentPath === newProjectPath;
  const isBlockrailTheme = featureConfig.isBlockrailTheme;

  const { classes, cx } = useFooterStyles({ isBlockrailTheme });

  return (
    <div
      className={cx(classes.root, {
        [classes.hidden]: isNewProjectPage,
      })}
    >
      <div className={cx(classes.item, classes.docs)}>
        {isBlockrailTheme ? (
          <BlockrailLogo className={classes.logo} />
        ) : (
          <AnkrLogo className={classes.logo} />
        )}
        <Typography
          className={classes.copyRightsLink}
          variant="body3"
          color="textSecondary"
        >
          {t(
            featureConfig.isBlockrailTheme
              ? 'footer.all-rights-blockrail'
              : 'footer.all-rights',
            {
              year: new Date().getFullYear(),
            },
          )}
        </Typography>
        <Divider orientation="vertical" className={classes.divider} />
        <Link
          className={cx(classes.link, classes.termsLink)}
          href={ANKR_TERMS_OF_SERVICE_LINK}
          target="_blank"
          variant="body3"
          color="textSecondary"
        >
          {t('footer.terms')}
        </Link>
        <Link
          className={cx(classes.link, classes.privacyLink)}
          href={ANKR_PRIVACY_POLICY_LINK}
          target="_blank"
          variant="body3"
          color="textSecondary"
        >
          {t('footer.privacy')}
        </Link>
      </div>
    </div>
  );
};
